module.exports = __webpack_public_path__ + "static/media/ipayLogo.bca13908.png";